<header
  class="site-header sticky top-0 z-50 border-b border-base-content/5 bg-base-100/80 backdrop-blur-lg"
  [class.site-header-transparent]="!isHomeRoute()">
  <div class="navbar mx-auto max-w-7xl gap-2 px-4 md:px-6">
    <div class="flex-none">
      @let info = settingStore.companyInfo();
      <a routerLink="/" class="group flex items-center gap-2.5">
        @if (info.logo) {
          <img
            [src]="info.logo"
            alt="Logo"
            class="h-8 min-w-20 w-auto transition-transform duration-200 group-hover:scale-105"
            (error)="onLogoError($event)" />
        } @else {
          <img
            [src]="defaultLogoUrl"
            alt="Logo"
            class="h-8 min-w-20 w-auto transition-transform duration-200 group-hover:scale-105"
            (error)="onLogoError($event)" />
        }
      </a>
    </div>

    <nav class="ml-8 hidden flex-1 items-center gap-1 lg:flex">
      @for (item of navItems(); track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="nav-active"
          [routerLinkActiveOptions]="{ exact: item.path === '/' }"
          class="nav-link group">
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>

    <div class="flex-1 lg:hidden"></div>

    <div class="hidden flex-none items-center gap-1 lg:flex">
      <div class="mx-2 h-4 w-px bg-base-content/10"></div>

      <div class="dropdown dropdown-end">
        <div
          tabindex="0"
          role="button"
          class="group btn btn-xs gap-1.5 rounded-full border-none bg-transparent px-3 py-1 text-white shadow-none transition-all duration-200">
          <span [class]="currentLang().flag + ' text-lg'"></span>
          <span
            class="icon-[mdi--chevron-down] text-xs text-white opacity-100 transition-all duration-200 group-hover:text-white"></span>
        </div>
        <ul
          tabindex="0"
          class="dropdown-content menu z-50 mt-2 w-36 rounded-2xl border border-base-content/5 bg-base-100 p-1.5 shadow-xl">
          @for (lang of languages; track lang.code) {
            <li>
              <button
                (click)="changeLanguage(lang)"
                [class.active]="currentLang().code === lang.code"
                class="flex w-full items-center justify-start gap-3 rounded-none px-4 py-3 text-sm">
                <span [class]="lang.flag + ' text-lg'"></span>
                <span class="flex-1">{{ lang.label }}</span>
                @if (currentLang().code === lang.code) {
                  <span class="icon-[mdi--check] text-base text-primary"></span>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="flex-none items-center lg:hidden">
      <button
        class="btn btn-ghost btn-sm btn-square rounded-xl"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="'LAYOUT.HEADER.OPEN_MENU' | translate">
        <span class="icon-[mdi--menu] text-xl text-white"></span>
      </button>
    </div>
  </div>
</header>

@if (mobileMenuOpen()) {
  <div class="fixed inset-0 z-998 lg:hidden">
    <button
      class="absolute inset-0 bg-black/40 backdrop-blur-sm"
      (click)="closeMobileMenu()"
      [attr.aria-label]="'LAYOUT.HEADER.CLOSE_MENU' | translate"></button>

    <aside
      class="site-mobile-menu absolute top-0 right-0 flex h-full w-[80%] animate-slide-in-right flex-col bg-base-100 shadow-2xl">
      <div class="flex items-center justify-between border-b border-base-content/5 px-5 py-4">
        <a routerLink="/" (click)="closeMobileMenu()" class="flex items-center gap-2">
          @if (settingStore.companyInfo().logo) {
            <img [src]="settingStore.companyInfo().logo" alt="Logo" class="h-7 w-auto" (error)="onLogoError($event)" />
          } @else {
            <img [src]="defaultLogoUrl" alt="Logo" class="h-7 w-auto" (error)="onLogoError($event)" />
          }
        </a>
        <button
          class="btn btn-ghost btn-sm btn-square rounded-xl"
          (click)="closeMobileMenu()"
          [attr.aria-label]="'LAYOUT.HEADER.CLOSE_MENU' | translate">
          <span class="icon-[mdi--close] text-xl text-base-content/50"></span>
        </button>
      </div>

      <nav class="flex flex-1 flex-col gap-0.5 p-3">
        @for (item of navItems(); track item.path) {
          <a
            [routerLink]="item.path"
            routerLinkActive="bg-primary/8 text-primary font-semibold"
            [routerLinkActiveOptions]="{ exact: item.path === '/' }"
            (click)="closeMobileMenu()"
            class="flex items-center gap-3 rounded-xl px-4 py-3.5 text-base-content/70 transition-all duration-200 hover:bg-base-200/70">
            <span [class]="item.icon + ' text-xl'"></span>
            <span class="text-sm font-medium">{{ item.label }}</span>
          </a>
        }
      </nav>

      <div class="border-t border-base-content/5 p-4">
        <div class="flex items-center gap-1 rounded-xl bg-base-200/50 p-1">
          @for (lang of languages; track lang.code) {
            <button
              (click)="changeLanguage(lang)"
              [class]="
                'flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-medium transition-all duration-200 ' +
                (currentLang().code === lang.code ? 'bg-base-100 shadow-sm text-base-content' : 'text-base-content/40')
              ">
              <span [class]="lang.flag + ' text-sm'"></span>
              <span>{{ lang.label }}</span>
            </button>
          }
        </div>
      </div>
    </aside>
  </div>
}
